/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGuestDto } from '../../models/create-guest-dto';
import { Guest } from '../../models/guest';

export interface GuestsControllerCreate$Params {
      body: CreateGuestDto
}

export function guestsControllerCreate(http: HttpClient, rootUrl: string, params: GuestsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Guest>> {
  const rb = new RequestBuilder(rootUrl, guestsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Guest>;
    })
  );
}

guestsControllerCreate.PATH = '/admin/guests';
